import { createSelector } from 'reselect';
import { get, findIndex } from 'lodash';
import { surveyStatusEnum } from 'containers/SurveysPage/constants';
import {
  makeSelectIsDistributionLink,
  makeSelectSurveyStatusName,
} from 'containers/Survey/selectors';
import { SURVEY_PROCEED_QUESTIONNAIRE_ERROR_CODES } from '../SurveyProceed/constants';

/**
 * Direct selector to the linkShare state domain
 */
const selectLinkShareDomain = (state) => get(state, 'linkShare', {});

/**
 * Other specific selectors
 */

/**
 * Default selector used by LinkShare
 */

const makeSelectLinkShare = createSelector(
  selectLinkShareDomain,
  (substate) => substate,
);

const makeSelectIsSaving = createSelector(selectLinkShareDomain, (substate) =>
  get(substate, 'isSaving', false),
);

const makeSelectAudienceError = createSelector(
  selectLinkShareDomain,
  (substate) => {
    const { surveyErrors = [] } = substate;
    return (
      findIndex(
        surveyErrors,
        (error) =>
          error === 'ERROR_CHECKOUT_AUDIENCE' ||
          error === 'ERROR_CHECKOUT_TARGETING', // this is to handle errors for screening questions which return this error type
      ) !== -1
    );
  },
);

const makeSelectQuestionnaireError = createSelector(
  selectLinkShareDomain,
  (substate = {}) => {
    const { surveyErrors = [] } = substate;
    return SURVEY_PROCEED_QUESTIONNAIRE_ERROR_CODES.some((error) =>
      surveyErrors.includes(error),
    );
  },
);

const makeSelectScreeningQuestionnaireError = createSelector(
  selectLinkShareDomain,
  (substate = {}) => {
    const { surveyErrors = [] } = substate;
    return (
      findIndex(
        surveyErrors,
        (error) => error === 'ERROR_CHECKOUT_SCREENING_QUESTIONNAIRE',
      ) !== -1
    );
  },
);

const makeSelectSettingsError = createSelector(
  selectLinkShareDomain,
  (substate) => {
    const { surveyErrors = [] } = substate;
    return (
      findIndex(
        surveyErrors,
        (error) => error === 'ERROR_CHECKOUT_SETTINGS',
      ) !== -1
    );
  },
);

const makeSelectSurveyErrors = createSelector(
  selectLinkShareDomain,
  (substate) => {
    const { surveyErrors = [] } = substate;
    return surveyErrors;
  },
);

const makeSelectShowLinkValidationErrors = createSelector(
  [makeSelectIsDistributionLink, makeSelectSurveyStatusName],
  (isDistributionLink, surveyStatusName) => {
    const showErrors = [
      surveyStatusEnum.DRAFT,
      surveyStatusEnum.UNDER_EDIT,
      surveyStatusEnum.UNDER_APPROVAL,
    ].includes(surveyStatusName);
    if (isDistributionLink) {
      return showErrors;
    }
    return true;
  },
);

const makeSelectHasHiddenVariablesError = createSelector(
  selectLinkShareDomain,
  (substate) => {
    const { surveyErrors = [] } = substate;
    return (
      findIndex(
        surveyErrors,
        (error) => error === 'ERROR_CHECKOUT_HIDDEN_VARIABLES',
      ) !== -1
    );
  },
);

export default makeSelectLinkShare;
export {
  selectLinkShareDomain,
  makeSelectIsSaving,
  makeSelectAudienceError,
  makeSelectQuestionnaireError,
  makeSelectSettingsError,
  makeSelectSurveyErrors,
  makeSelectShowLinkValidationErrors,
  makeSelectScreeningQuestionnaireError,
  makeSelectHasHiddenVariablesError,
};
